export var ScalarOperators;
(function (ScalarOperators) {
    ScalarOperators["IN_OPERATOR"] = "IN";
    ScalarOperators["NOT_IN_OPERATOR"] = "NOT_IN";
    ScalarOperators["SCALAR_OPERATOR_UNSPECIFIED"] = "UNSPECIFIED";
})(ScalarOperators || (ScalarOperators = {}));
